import { TableColumnSchema } from 'polly-qubit';
import { DropDownInterface } from 'polly-commons';

export const DEFAULT_PIPELINE_PAGE_SIZE: number = 25;
export const MARKDOWN_DIVIDER = '@@MARKDOWN_DIVIDER@@';
export const NEW_RUN_DROPDOWN_OPTION: string = '+ Create New Batch';
export const TEN_MINUTES = 600000;
export const PIPELINES_LANDING_PAGE_PATH = '/manage/pipelines';

export const PRAVAAH_API_ENDPOINT: { [key: string]: string } = {
  ORCHESTRATION: 'pravaah/orchestration',
  IMPORTER: 'pravaah/importer',
};

export const SOURCE_DETAILS_CONFIG: { [key: string]: string | boolean }[] = [
  {
    id: 'sourceNmae',
    placeholder: 'Enter Source Name',
    formControlName: 'sourceName',
    label: 'Source Name',
    required: true,
  },
  {
    id: 'sourceDescription',
    placeholder: 'Enter Source Description',
    formControlName: 'sourceDescription',
    label: 'Source Description',
    required: true,
  },
  {
    id: 'accessKeyId',
    placeholder: 'Enter Access Key ID',
    formControlName: 'accessKeyId',
    label: 'Access Key Id',
    required: true,
  },
  {
    id: 'secretAccessKey',
    placeholder: 'Enter Secret Access Key',
    formControlName: 'secretAccessKey',
    label: 'Secret Access Key',
    required: true,
  },
  {
    id: 'regionName',
    placeholder: 'Enter Region Name',
    formControlName: 'regionName',
    label: 'Region',
    required: true,
  },
  {
    id: 'bucketName',
    placeholder: 'Enter Bucket Name',
    formControlName: 'bucketName',
    label: 'Bucket Name',
    required: true,
  },
  {
    id: 'accessToken',
    placeholder: 'Enter Access Token',
    formControlName: 'accessToken',
    label: 'Access Token',
    required: true,
  },
  {
    id: 'basespaceUrl',
    placeholder: 'BaseSpace Url',
    formControlName: 'basespaceUrl',
    label: 'BaseSpace Url',
    description: 'Custom API endpoint for dedicated BaseSpace tenants. Leave blank if not sure',
  },
];

export const PIPELINES_TABLE_COLUMNS: TableColumnSchema[] = [
  {
    original_name: 'display_name',
    type: 'text',
    display_name: 'Pipeline Name',
    width: 25,
  },
  {
    original_name: 'description',
    type: 'text',
    display_name: 'Description',
    width: 35,
  },
  {
    original_name: 'created_at',
    type: 'date',
    display_name: 'Created On',
    width: 12,
  },
  {
    original_name: 'action',
    type: 'button',
    display_name: 'Actions',
    width: 7,
  },
];

export enum PipelineRoles {
  MANAGER = 'manager',
  COLLABORATOR = 'collaborator',
  CONSUMER = 'consumer',
}

export const COLLABORATORS_TABLE_COLUMNS: TableColumnSchema[] = [
  {
    display_name: 'User Name',
    original_name: 'user_name',
    type: 'badge',
    width: 20.1875,
  },
  {
    display_name: 'Role',
    original_name: 'access_type',
    type: 'text',
    width: 10,
  },
  {
    display_name: 'Actions',
    original_name: 'actions',
    type: 'button',
    width: 6,
  },
];

export const ACCESS_RIGHTS: DropDownInterface[] = [
  {
    label: 'Manager',
    value: PipelineRoles.MANAGER,
  },
  {
    label: 'Collaborator',
    value: PipelineRoles.COLLABORATOR,
  },
];

export enum PIPELINES_TITLES {
  OVERVIEW = 'Overview',
  LATEST_ISSUES = 'Latest Issues',
};

